import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';
import { mapParamsBySchema } from '../../../../util';
import Global from '../../../../Services/Common/Global';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import { M_RNM_DAI_03_Schema } from './M_RNM_DAI_03_Schema';

/** 안전신문고 조치 저장 SaveAccBasic02U2 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const [row = {}] = rows ?? [];
    const payload = mapParamsBySchema(M_RNM_DAI_03_Schema.mapper.save1, row);
    return apiRequest('post1', Global.urls.WorkInfo.saveAccBasic02U2, payload);
  }, options);
};
